import React, { useState } from "react"

import { ActionButton } from "../../../components/utils/ActionButton"
import { PlusIcon } from "../../../resources/icons/PlusIcon"

export const InterstitialZone = () => {
    const [state, setstate] = useState({
        posting: false
    })

    return (
        <React.Fragment>
            <div className="w-full flex flex-row-reverse">
                <div className="flex-none pt-3">
                    <ActionButton
                        variant="ghost"
                        posting={state.posting}
                        actionName={
                            <div className="flex align-middle items-center gap-1">
                                <PlusIcon />

                                <span className="text-sm">New Entry</span>
                            </div>
                        }
                    />
                </div>
            </div>
        </React.Fragment>
    )
}